export const minimalZ3KConfig = {
    counters: {},
    device: {
        name: 'UNKNOWN',
        firmware: '0',
        hardware: '0',
    },
    login: '',
    timezone: 3,
    port: 52200,
};
export const minimalZ3KConfigWithFoundedBoilerAdapter = {
    ...minimalZ3KConfig,
    boiler_adapters: [
        {
            id: 4096,
            adapter_type: 9,
            boiler_model: '',
            hardware: 'v45.00',
            isManual: false,
            logged_parameter_register: 383,
            max_modulation_level: 100,
            name: 'АЦШ',
            position: 0,
            processor: 5,
            rol_boiler_failure: [],
            rol_boiler_restore: [],
            rol_connection_found: [],
            rol_connection_lost: [],
            serial: { builtIn: false, value: '556612' },
            slot: 0,
            type: 1,
        },
    ],
};
